import script from "./tableConfigDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./tableConfigDialog.vue?vue&type=script&lang=ts&setup=true"

import "./tableConfigDialog.vue?vue&type=style&index=0&id=ffa443ac&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa443ac"]])

export default __exports__